import { useEffect, useState } from "react";
import { Modal, Form, Input } from "antd";

import { password_regexp } from "helpers/regexp";

import useFormErrors from "hooks/useFormErrors";

import { useAuth } from "context/providers/auth";

const ChangePasswordModal = ({ is_open, handleClose }) => {
  const [is_loading, setLoading] = useState(false);
  const { changePassword } = useAuth();

  const [form] = Form.useForm();

  const { pristine, has_error, onFieldsChange } = useFormErrors();

  const handleOk = () => form.submit();

  useEffect(() => {
    form.resetFields();
    // eslint-disable-next-line
  }, [is_open]);

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      title="Zmień hasło"
      open={is_open}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Zmień"
      okButtonProps={{
        disabled: pristine || has_error,
        loading: is_loading,
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFieldsChange={onFieldsChange}
        initialValues={{
          current_password: "",
          password: "",
          password_confirmation: "",
        }}
        onFinish={async ({
          current_password,
          password,
          password_confirmation,
        }) => {
          try {
            setLoading(true);
            await changePassword({
              current_password,
              password,
              password_confirmation,
            });
            handleClose();
          } catch (error) {
          } finally {
            setLoading(false);
          }
        }}
      >
        <Form.Item
          label="Stare hasło"
          name="current_password"
          required
          hasFeedback
          rules={[
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(new Error("Pole wymagane"));
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password maxLength={128} />
        </Form.Item>
        <Form.Item
          label="Nowe hasło"
          name="password"
          required
          hasFeedback
          rules={[
            {
              required: true,
              message: "Hasło jest wymagane!",
            },
            {
              max: 128,
              message: "Przekroczono maksymalną ilość znaków!",
            },
            {
              min: 8,
              message: "Hasło musi mieć co najmniej 8 znaków!",
            },
            {
              pattern: password_regexp,
              message:
                "Hasło musi zawierać przynajmniej jedną dużą literę, jedną cyfrę i jeden znak specjalny!",
            },
          ]}
        >
          <Input.Password maxLength={128} />
        </Form.Item>
        <Form.Item
          label="Potwierdź hasło"
          name="password_confirmation"
          dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: "Potwierdzenie hasła jest wymagane!",
            },

            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Hasła muszą być takie same!"));
              },
            }),
          ]}
        >
          <Input.Password maxLength={128} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
